import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { id: "countryname" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "temp" }
const _hoisted_7 = { id: "tempdeg" }
const _hoisted_8 = { class: "rainorsunny" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: "weather",
      class: _normalizeClass(
        typeof _ctx.weather.main != 'undefined' &&
        _ctx.weather.weather[0].main.toString().toLowerCase() == 'clouds'
          ? 'cloudyimg'
          : typeof _ctx.weather.main != 'undefined' &&
            _ctx.weather.weather[0].main.toString().toLowerCase() == 'rain'
          ? 'rainyimg'
          : _ctx.devcount === 1
          ? 'graybgc'
          : ''
      )
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Search...",
        onKeypress: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.fetchingapi()), ["enter"])),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
        spellcheck: "false"
      }, null, 544), [
        [_vModelText, _ctx.query]
      ]),
      _hoisted_1,
      _hoisted_2,
      (typeof _ctx.weather.main != 'undefined')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.weather.name) + "," + _toDisplayString(_ctx.weather.sys.country), 1)
              ]),
              _: 1
            }),
            _createElementVNode("h4", null, _toDisplayString(_ctx.getdate()), 1),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(Math.round(_ctx.weather.main.temp)) + "°c", 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.weather.weather[0].main), 1)
          ]))
        : (_ctx.hintcount == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Type the name of the city and then hit Enter "))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("li", null, [
          (_ctx.devcount == 1)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "mailto:jihadmahfouz8@gmail.com",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hide()))
              }, "Send Feedback"))
            : _createCommentVNode("", true),
          (_ctx.devcount == 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onbtnclick()))
              }, "Not now"))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}